import React, { useEffect, useRef, useState } from "react";
import { Button, Checkbox, DatePicker, Input, notification, Table } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { GetSingleEmployeeData } from "../../../Services/CommonApis";
import { Date4, Text4 } from "../../../Components/FormComponents/InputFields";
import { Controller, useForm } from "react-hook-form";

import CustomEditableTable from "./Component/IdentityTable";
import {
  getColumnsConfig,
  getReferenceColumn,
} from "./Component/ComlumnConfig";
import {
  submitHistoryApi,
  submitJobDetailApi,
  submitIdentityDetail,
  submitEsicDetailApi,
  submitPfDetailApi,
  submitRefferenceApi,
} from "../../../api/IndentityApi";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getEmployeeDetailApi } from "../../../Services/EmployeeOnboarding";
import ApproveReject from "./Component/ApproveReject";

const defaultRelations = [
  { label: 1 },
  { label: 2 },
  { label: 3 },
  { label: 4 },
  { label: 5 },
];
const RefreshCount = [{ label: 1 }, { label: 2 }];

const defaultValues = {
  aadhar_number: "",
  pan_number: "",
  voter_id: "",
  passport_number: "",
  driving_license: "",
  department: "",
  designation: "",
  employee_id: "",
  location: "",
  work_location: "",
  date_of_joining: "",
  employee_type: "",
  reporting_manager_id: "",
  esic_number: "",
  dispensary_address: "",
  uan_number: "",
  pf_number: "",
  is_covered: null,
  pf_transfer_required: null,
};

export default function IdentityDetail() {
  const navigate = useNavigate();
  const { responseData, id, profileData } = useOutletContext();
  const [tableData, setTableData] = useState(defaultRelations);
  const [isLoading, setIsLoading] = useState(false);
  const [output, setOutput] = useState(null);
  const [disableFields, setDisabledFields] = useState("");

  const [isUpdate, setIsUpdate] = useState(false)
  const [isEsic, setisEsic] = useState(false);
  const [reffrenceOutput, setRefferenceOutput] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const handleChangeValue = (value, field, relation) => {
    setOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const handleChangeRefference = (value, field, relation) => {
    setRefferenceOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const ReferenceColumn = getReferenceColumn(handleChangeRefference);
  const columnsConfig = getColumnsConfig(handleChangeValue);

  const counter = useRef(0);

  function generateSimpleId() {
    return (
      "id-" +
      (counter.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }

  const handleAddRow = () => {
    setTableData((prev) => [
      ...prev,
      {
        label: generateSimpleId(),
      },
    ]);
  };

  const handleRemoveRow = (labelToRemove) => {
    setTableData((prev) => prev.filter((row) => row.label !== labelToRemove));
  };

  const onerror = (error) => {
    console.log(error);
  };

  const handleSubmittingFun = async (apiHitFun) => {
    try {
      setIsLoading(true);
      const { data } = await apiHitFun();
      setIsLoading(false);

      const message = data?.message?.toLowerCase() || "";

      const isAcceptableMessage =
        message.includes("already updated") ||
        message.includes("no changes made");
      if (isAcceptableMessage) {
        return true;
      }
      if (data.success) {
        api.success({ message: data.message, placement: "top" });
        return true;
      } else {
        api.error({ message: data.message, placement: "top" });
        return false;
      }
    } catch (e) {
      api.error({ message: "Something went wrong", placement: "top" });
      return false;
    }
  };

  const onSubmit = async (val) => {
    const isIdentitySuccess = await handleSubmittingFun(() =>
      submitIdentityDetail(val, id, isUpdate)
    );

    if (!isIdentitySuccess) return;

    const arrayOfValues = Object.values(output);

    const isEmployeeHistory = await handleSubmittingFun(() =>
      submitHistoryApi(arrayOfValues, id , isUpdate)
    );

    if (!isEmployeeHistory) return;

    const ReffreshValue = Object.values(reffrenceOutput);
    const isRefference = await handleSubmittingFun(() =>
      submitRefferenceApi(ReffreshValue, id, isUpdate)
    );

    if (!isRefference) return;

    // const isJobDetail = await handleSubmittingFun(() =>
    //   submitJobDetailApi(val)
    // );

    // if (!isJobDetail) return;

    const isEsicDetail = await handleSubmittingFun(() =>
      submitEsicDetailApi(val, id, isUpdate)
    );

    if (!isEsicDetail) return;

    const isPfDetail = await handleSubmittingFun(() => submitPfDetailApi(val,id, isUpdate));
    if (isPfDetail) {
      if(isUpdate) {
          setIsUpdate(false)
          return
      }
     else {
      if (responseData?.final_submit) {
        handleSubmitFinal();
      } else {
        navigate("/new-user/bank-details");
      }
     }
     
    }
  };

  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/bank-details");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };

  const getHistoryDetail = async (responseData) => {
    const profile = profileData || {};
    const disableFields = {};

    setOutput((prev) => {
      const updated = { ...prev };
      const list = responseData?.employment_history || [];

      list.forEach((item, index) => {
        const profileItem = profile?.employment_history?.[index] || {};

        const from_date = profileItem.from_date ?? item.from_date;
        const to_date = profileItem.to_date ?? item.to_date;

        // Mark disable if profile data exists
        if (profileItem.from_date) {
          disableFields[`employment_history.${index}.from_date`] = true;
        }
        if (profileItem.to_date) {
          disableFields[`employment_history.${index}.to_date`] = true;
        }

        updated[index + 1] = {
          ...item,
          ...profileItem,
          duration: [from_date, to_date],
        };
      });

      setDisabledFields((prev) => ({ ...prev, ...disableFields }));
      return updated;
    });
  };

  const getRefferenceDetail = async (responseData) => {
    const profile = profileData || {};
    const disableFields = {};

    setRefferenceOutput((prev) => {
      const updated = { ...prev };
      const list = responseData?.reference_details || [];

      list.forEach((item, index) => {
        const profileItem = profile?.reference_details?.[index] || {};

        const from_date = profileItem.from_date ?? item.from_date;
        const to_date = profileItem.to_date ?? item.to_date;

        if (profileItem.from_date) {
          disableFields[`reference_details.${index}.from_date`] = true;
        }
        if (profileItem.to_date) {
          disableFields[`reference_details.${index}.to_date`] = true;
        }

        updated[index + 1] = {
          ...item,
          ...profileItem,
          duration: [from_date, to_date],
        };
      });

      setDisabledFields((prev) => ({ ...prev, ...disableFields }));
      return updated;
    });
  };

  const getAllDetail = async (responseData) => {
    const profile = profileData || {};
    const disableFields = {};

    const getValue = (path) => {
      const profileVal = path.reduce((acc, key) => acc?.[key], profile);
      const responseVal = path.reduce((acc, key) => acc?.[key], responseData);
      const fieldKey = path.join(".");

      if (
        profileVal !== undefined &&
        profileVal !== null &&
        profileVal !== ""
      ) {
        disableFields[fieldKey] = true;
        return profileVal;
      }

      return responseVal;
    };

    const idCardsFields = [
      "aadhar_number",
      "driving_license",
      "pan_number",
      "passport_number",
      "voter_id",
    ];
    const jobDetailsFields = ["employee_type", "location"];
    const esicFields = ["esic_number", "dispensary_address", "is_covered"];
    const pfFields = ["pf_number", "uan_number", "pf_transfer_required"];

    const idCardsValues = {};
    idCardsFields.forEach((key) => {
      const val = getValue(["id_cards", key]);
      if (val !== undefined) idCardsValues[key] = val;
    });

    const jobDetailsValues = {};
    jobDetailsFields.forEach((key) => {
      const val = getValue(["job_details", key]);
      if (val !== undefined) jobDetailsValues[key] = val;
    });

    const esicValues = {};
    esicFields.forEach((key) => {
      const val = getValue(["esic_details", key]);
      if (val !== undefined) esicValues[key] = val;
    });

    const pfValues = {};
    pfFields.forEach((key) => {
      const val = getValue(["pf_details", key]);
      if (val !== undefined) pfValues[key] = val;
    });

    const updatedValues = {
      ...defaultValues,
      ...idCardsValues,
      ...jobDetailsValues,
      ...esicValues,
      ...pfValues,
      employee_id: getValue(["employee_id"]),
      designation: getValue(["designation"]),
      date_of_joining: getValue(["date_of_joining"]),
      department: getValue(["function"]),
      reporting_manager_id: getValue(["reporting_manager", "employee_id"]),
    };

    setisEsic(responseData?.esic_details?.is_covered);
    setDisabledFields((prev) => ({ ...prev, ...disableFields }));
    reset(updatedValues);
  };

  const getEmployeeDetail = async () => {
    getHistoryDetail(responseData);
    getRefferenceDetail(responseData);
    getAllDetail(responseData);
  };

  const {
    pf_details_meta,
    reference_details_meta,
    esic_details_meta,
    employment_history_meta,
    id_cards_meta,
  } = responseData?.final_submit || {};
  const is_Final_submit =
    pf_details_meta?.final_submit === true &&
    reference_details_meta?.final_submit === true &&
    employment_history_meta?.final_submit === true &&
    id_cards_meta?.final_submit === true &&
    esic_details_meta?.final_submit === true;

  const is_approved =
    pf_details_meta?.is_approved === true &&
    reference_details_meta?.is_approved === true &&
    employment_history_meta?.is_approved === true &&
    id_cards_meta?.is_approved === true &&
    esic_details_meta?.is_approved === true;

  const type = sessionStorage.getItem("userType");

  useEffect(() => {
    if (responseData) {
      getEmployeeDetail();

      setDisabledFields((prev) => ({
        ...prev,
        ["id_cards.aadhar_number"]: true,
        ["id_cards.pan_number"]: true,
        ["gender"]: true,
        ["mobile"]: true,
        ["email.personal"]: true,
      }));
    }
  }, [reset]);

  return (
    <>
      {contextHolder}

      <form
        className="responsive-form"
        onSubmit={handleSubmit(onSubmit, onerror)}
      >
        
        <div
          className="p-0 responsive-row mt-3"
          style={{ borderRadius: "10px" }}
        >

          {/* Identity Details */}
          <div className="flex justify-between"> 
            <h3 className="color-heading">Identity Details</h3>

             {isUpdate &&  <Button onClick={()=>setIsUpdate(false)}  style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} shape="circle" icon={ <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                </svg> }> 
         </Button>||  <Button onClick={()=>setIsUpdate(true)}  style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} shape="circle" icon={<svg  xmlns="http://www.w3.org/2000/svg" width="16"  fill="currentColor" className="bi bi-pencil-fill m-auto " viewBox="0 0 16 16">
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
            </svg>}> 
         </Button> }
        
          </div>
         
          <div className="flex mt-4 flex-wrap">
            <Text4
              control={control}
              errors={errors}
              id="aadhar_number"
              disabled={disableFields["id_cards.aadhar_number"]}
              name="Aadhar Card Number"
              label="Aadhar Card Number"
              type="number"
              validations={{
                required: true,
                pattern: {
                  value: /^\d{12}$/,
                  message: "Aadhar number must be exactly 12 digits",
                },
              }}
              maxLength={12}
            />

            <Text4
              control={control}
              errors={errors}
              id="pan_number"
              disabled={disableFields["id_cards.pan_number"]}
              name="Pan Card Number"
              label="PAN Card Number"
              validations={{
                required: true,
              
              }}
           
            />
            <Text4
              control={control}
              errors={errors}
              id="voter_id"
              name="Voter Id Number"
              label="Voter ID Number"
              disabled={disableFields["id_cards.voter_id"]}
              // validations={{
              //   required: true,
              //   pattern: {
              //     value: /^[A-Z]{3}[0-9]{7}$/,
              //     message: "Invalid Voter ID format (e.g., ABC1234567)",
              //   },
              // }}
            />
            <Text4
              control={control}
              errors={errors}
              id="passport_number"
              disabled={disableFields["id_cards.passport_number"]}
              name="Passport Number"
              label="Passport Number"
              // validations={{
              //   required: true,
              //   pattern: {
              //     value: /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/,
              //     message: "Invalid passport number. Example: A1234567",
              //   },
              // }}
              example="Example: A1234567"
            />
            <Text4
              control={control}
              errors={errors}
              id="driving_license"
              name="Driving License"
              label="Driving License"
              disabled={disableFields["id_cards.driving_license"]}
              validations={{
                pattern: {
                  value: /^[A-Z]{2}\d{2} ?\d{11}$/,
                  message:
                    "Invalid driving license number. Example: DL01 12345678901",
                },
              }}
            />
          </div>
          {/* Employment History */}
          <h3 className="color-heading mt-4 mb-4">Employment History</h3>
          <CustomEditableTable
            handleAddRow={handleAddRow}
            handleRemoveRow={handleRemoveRow}
            columnsConfig={columnsConfig}
            tableData={tableData}
            setTableData={setTableData}
            output={output}
            setOutput={setOutput}
            isLoading={isLoading}
          />
          {/* Reference Details */}
          <h3 className="color-heading mt-5 mb-4">Reference Details</h3>
          <CustomEditableTable
            columnsConfig={ReferenceColumn}
            tableData={RefreshCount}
            output={reffrenceOutput}
            setOutput={setRefferenceOutput}
            isLoading={isLoading}
          />
          {/* Job/Position Details */}
          {/* <h3 className="color-heading mt-5 mb-4">Job/Position Details</h3>
          <div className="flex mt-4 flex-wrap">
            <Text4
              control={control}
              errors={errors}
              id="department"
              name="Department"
              disabled={disableFields["function"]}
              label="Department"
              validations={{ required: true }}
            />
            <Text4
              control={control}
              errors={errors}
              id="designation"
              name="Designation"
              label="Designation"
              disabled={disableFields["designation"]}
              validations={{ required: true }}
            />
            <Text4
              control={control}
              errors={errors}
              id="employee_id"
              disabled={disableFields["employee_id"]}
              name="Employee Id"
              label="Employee ID"
              validations={{ required: true }}
            />
            <Text4
              control={control}
              errors={errors}
              id="location"
              name="Location"
              label="Location"
              disabled={disableFields["job_details.location"]}
              validations={{ required: true }}
            />
            <Text4
              control={control}
              errors={errors}
              id="work_location"
              name="Work Location"
              label="Work Location"
            />
            {/* <Text4
              control={control}
              errors={errors}
              id="date_of_joining"
              name="Joining Date"
              label="Joining Date"
            /> */}
          {/* <Date4
            control={control}
            errors={errors}
            id="date_of_joining"
            name="Joining Date"
            disabled={disableFields["date_of_joining"]}
           
          /> */}
          {/* <Text4
            control={control}
            errors={errors}
            id="employee_type"
            name="Employee Type"
            disabled={disableFields["job_details.employee_type"]}
            label="Employee Type"
          /> */}
          {/* <Text4
            control={control}
            errors={errors}
            id="reporting_manager_id"
            name="Reporting Manager Id"
            disabled={disableFields["reporting_manager.employee_id"]}
            label="Reporting Manager ID"
          /> */}
          {/* </div> */}
          {/* */}

          {/* ESIC Details */}
          <h3 className="color-heading mt-5 mb-4">ESIC Details</h3>
          <p className="text-sm">Is the employee covered under ESIC?</p>
          <div style={{ display: "flex", gap: 20, marginBottom: 12 }}>
            <Controller
              control={control}
              name="is_covered"
              render={({ field }) => {
                const disable = disableFields["esic_details.is_covered"];
                return (
                  <>
                    <Checkbox
                      checked={field.value === true}
                      onChange={(e) => {
                        field.onChange(e.target.checked ? true : false);
                        setisEsic(true);
                      }}
                      disabled={disable}
                    >
                      Yes
                    </Checkbox>
                    <Checkbox
                      checked={field.value === false}
                      onChange={(e) => {
                        field.onChange(e.target.checked ? false : null);
                        setisEsic(false);
                      }}
                      disabled={disable}
                    >
                      No
                    </Checkbox>
                  </>
                );
              }}
            />
          </div>
          {isEsic && (
            <div className="flex mt-2 flex-wrap">
              <Text4
                control={control}
                errors={errors}
                id="esic_number"
                name="Esic Number"
                label="ESIC Number"
                // validations={{
                //   required: true,
                //   pattern: {
                //     value: /^\d{17}$/,
                //     message:
                //       "ESIC number must be exactly 17 digits. Example: 12345678901234567",
                //   },
                // }}
                // example="Example: 12345678901234567"
              />

              <Text4
                control={control}
                errors={errors}
                id="dispensary_address"
                name="Esic Address"
                label="ESIC Address"
                // validations={{ required: true }}
                // example="Example: Sector 5 Dispensary, Delhi"
              />
            </div>
          )}

          {/* PF & UAN Details */}
          <h3 className="color-heading mt-5 mb-4">PF & UAN Details</h3>
          <div className="flex mt-2 flex-wrap">
            <Text4
              control={control}
              errors={errors}
              id="uan_number"
              name="UAN Number"
              disabled={disableFields["pf_details.uan_number"]}
              label="UAN Number"
              // validations={{
              //   required: true,
              //   pattern: {
              //     value: /^\d{12}$/,
              //     message: "UAN must be exactly 12 digits",
              //   },
              // }}
            />

            <Text4
              control={control}
              errors={errors}
              id="pf_number"
              disabled={disableFields["pf_details.pf_number"]}
              name="PF Account Number"
              label="PF Account Number"
            />
          </div>
          <p className="text-sm">Previous Company PF Transfer Required?</p>
          <div style={{ display: "flex", gap: 20, marginBottom: 12 }}>
            <Controller
              control={control}
              name="pf_transfer_required"
              render={({ field }) => {
                const disable =
                  disableFields["pf_details.pf_transfer_required"];
                return (
                  <>
                    <Checkbox
                      checked={field.value === true}
                      onChange={(e) =>
                        field.onChange(e.target.checked ? true : null)
                      }
                      disabled={disable}
                    >
                      Yes
                    </Checkbox>
                    <Checkbox
                      checked={field.value === false}
                      onChange={(e) =>
                        field.onChange(e.target.checked ? false : null)
                      }
                      disabled={disable}
                    >
                      No
                    </Checkbox>
                  </>
                );
              }}
            />
          </div>
        </div>

        <br />
        {type !== "admin" && (
          <div>
            {(is_Final_submit && (
              <button
                className="pl-10 custom-primary-btn pr-10 float-right opacity-100"
                disabled={true}
              >
                {isLoading ? "Submitting...." : "Submit "}
              </button>
            )) || (
              <button
                type="submit"
                className="pl-10 custom-primary-btn pr-10 float-right opacity-100"
                disabled={isLoading}
              >
                {isLoading ? "Submitting...." : "Submit "}
              </button>
            )}
          </div>
        ) || <>{isUpdate && <button
              className="m-2 pl-10 custom-primary-btn pr-10 float-right opacity-100 text-white step-button"
              type="submit"
            >
               Update 
            </button> }</>}
      </form>

      {type === "admin" && is_Final_submit && (
        <>
          {
            is_approved !== true && (
              <ApproveReject
                id={id}
                redirect="bank-details"
                detailType={[
                  "id_cards",
                  "employment_history",
                  "reference_details",
                  "job_details",
                  "esic_details",
                  "pf_details",
                ]}
              />
            )
            // <Button type="success" className="bg-green-500 text-white" disabled>
            //   ✓ Approved
            // </Button>
          }
        </>
      )}
    </>
  );
}
